import React from 'react';

const Button = ({
    children,
    variant = 'primary',
    size = 'md',
    className = '',
    disabled = false,
    onClick,
    type = 'button',
    ...props
}) => {
    const baseStyles = 'inline-flex items-center justify-center rounded-lg font-medium transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';

    const variants = {
        primary: 'bg-sm-primary text-white hover:bg-sm-primary/90 focus:ring-sm-primary',
        secondary: 'bg-sm-secondary text-white hover:bg-sm-secondary/90 focus:ring-sm-secondary',
        accent: 'bg-sm-accent text-white hover:bg-sm-accent/90 focus:ring-sm-accent',
        outline: 'border border-sm-border bg-transparent text-primary-text hover:bg-gray-bg focus:ring-sm-primary',
        ghost: 'bg-transparent text-primary-text hover:bg-gray-bg focus:ring-sm-primary',
        destructive: 'bg-destructive text-white hover:bg-destructive/90 focus:ring-destructive',
    };

    const sizes = {
        sm: 'px-3 py-1.5 text-xs',
        md: 'px-4 py-2 text-sm',
        lg: 'px-6 py-3 text-base',
        icon: 'p-2',
    };

    const combinedClassName = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;

    return (
        <button
            type={type}
            className={combinedClassName}
            disabled={disabled}
            onClick={onClick}
            {...props}
        >
            {children}
        </button>
    );
};

export default Button;
